import { Paper, Typography } from '@mui/material'
import React from 'react'

function InfoPaper({msg} : any) {
  return (
    <Paper elevation={5} sx={{
        padding: 2,
        margin: {
            lg:'20px auto',
            sm:'5px auto'
        },
        alignItems: 'center',
        color: '#000055',
        backgroundColor: '#bbbbff'
    }} >
        <Typography textAlign={'center'} > {msg} </Typography>
    </Paper>
  )
}

export default InfoPaper